// extracted by mini-css-extract-plugin
module.exports = {"root":"help_root__UCoZx","wrapper":"help_wrapper__BNvQR","title":"help_title__dYUAg","boldText":"help_boldText__mExOW","text":"help_text__8fhE1","help":"help_help__yT6hE"};